import { ArticleHeading4 } from '@cian/ui-kit';
import { BankListItem } from '../BankListItem';
import * as styles from './bankList.css';
import { IPromoBank } from '../../types/newbuilding/promoInfo';

interface IBankListProps {
  banks: IPromoBank[];
  onClick?(): void;
}

export function BankList({ banks, onClick }: IBankListProps) {
  if (banks.length === 1) {
    return <BankListItem bank={banks[0]} label={'Банк'} onClick={onClick} />;
  }

  return (
    <>
      <ArticleHeading4>Банки</ArticleHeading4>
      <ul className={styles['list']}>
        {banks.map(bank => (
          <li key={bank.id} className={styles['list-item']}>
            <BankListItem bank={bank} onClick={onClick} />
          </li>
        ))}
      </ul>
    </>
  );
}
